// extracted by mini-css-extract-plugin
export default {"resume":"ResumeContent_resume__ox1V+","header":"ResumeContent_header__ScZ6J","text":"ResumeContent_text__ggY5A"};